export * from './locations.interface';


